import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { vaultActions } from '@src/store/reducers/vaultReducer';

export const createVaultMiddleware =  (http: any, successPopUp: any, errorPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [vaultActions.GET_VAULT_TYPES]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Vault/Types`);
            const data = response.data;
            next({ type: vaultActions.SET_VAULT_TYPES, payload: data });
            return data;
        },
        [vaultActions.GET_VAULTS]:  async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Vault/Vaults`);
            const data = response.data;
            next({ type: vaultActions.SET_VAULTS, payload: data });
            return data;
        },
        [vaultActions.GET_VAULT_BY_ID]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Vault/Vault/${payload.vaultId}`);
            next({ type: vaultActions.SET_VAULT_BY_ID, payload: response.data });
            return response.data;
        },
        [vaultActions.SET_VAULT_CONFIGURATION]:  async ({ payload }: any) => {
            try {
                const url = `${restServiceUrl}Vault/AddConfiguration`;
                const response = await http.post(url, payload.vault_configuration);
                const data = response.data;
                if (data) {
                    successPopUp();
                } else {
                    errorPopUp();
                }
                return data;
            } catch {
                errorPopUp();
            }
        },
        [vaultActions.TEST_VAULT_CONNECTION]:  async ({ payload }: any, next: Next) => {
            try {
                const response = await http.post(`${restServiceUrl}Vault/Test`, payload.testData);
                const data = response.data;
                if (data) {
                    const messageObj = { message: 'Success Action - Test Vault Connection', text: '' };
                    successPopUp(messageObj);
                } else {
                    errorPopUp();
                }
                next({ type: vaultActions.REUSLT_TEST_VAULT_CONNECTION, payload: data });
            } catch {
                errorPopUp();
            }
        },
        [vaultActions.UPDATE_VAULT_CONFIGURATION]:  async ({ payload }: any) => {
            try {
                const response = await http.post(`${restServiceUrl}Vault/UpdateConfiguration`, payload.update_vault);
                const data = response.data;
                if (data) {
                    successPopUp();
                } else {
                    errorPopUp();
                }
                return data;
            } catch {
                errorPopUp();
            }
        },
        [vaultActions.DELETE_VAULT_CONFIGURATION]: async ({ payload }: any, next: Next) => {
            try {
                const response = await http.delete(`${restServiceUrl}Vault/DeleteConfiguration/${payload.vaultId}`);
                const data = response.data;
                if (data) {
                    successPopUp();
                    next({ type: vaultActions.REFRESH_DELETE_VAULT, payload: payload.vaultId });
                } else {
                    errorPopUp();
                }
                return response;
            } catch {
                errorPopUp();
            }
        },
        [vaultActions.GET_VAULTS_WITH_CREDENTIALS]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Vault/VaultsWithCredentials`);
            const data = response.data;
            next({ type: vaultActions.SET_VAULTS_WITH_CREDENTIALS, payload: data });
            return data;
        },
        [vaultActions.GET_VAULT_CONFIGURATION]: async ({ payload }: any) => {
            const response = await http.get(`${restServiceUrl}Vault/Template/Configuration/${payload.vaultTypeId}`);
            return response.data;
        },
        [vaultActions.GET_VAULT_CREDENTIALS]: async ({ payload }: any) => {
            const response = await http.get(`${restServiceUrl}Vault/Template/Credentials/${payload.vaultId}`);
            return response.data;
        },
        [vaultActions.GET_VAULT_CONNECTION]: async ({ payload }: any) => {
            const response = await http.get(`${restServiceUrl}Vault/Template/Connection/${payload.vaultId}`);
            return response.data;
        },
        [vaultActions.POST_VAULT_CREDENTIALS]: async ({ payload }: any) => {
            const response = await http.post(`${restServiceUrl}Vault/Template/Credentials/${ payload.vault.VaultTypeId}`, payload.vault);
            return response.data;
        },
        [vaultActions.POST_VAULT_CONNECTION]: async ({ payload }: any) => {
            const response = await http.post(`${restServiceUrl}Vault/Template/Connection/${payload.vault.VaultTypeId}`, payload.vault);
            return response.data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/vault.middleware.ts